(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sticky-add-to-cart')) {
    customElements.define(
      'sticky-add-to-cart',
      class StickyAddToCart extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.sectionId;
          this.target = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
          if (!this.target) return;

          this.button = this.querySelector('[data-sticky-button]');
          this.priceElement = this.querySelector('[data-sticky-price]');
          this.ticking = false;

          this.onScroll = () => {
            if (this.ticking) return;
            this.ticking = true;
            requestAnimationFrame(() => {
              this.ticking = false;
              this.refresh();
            });
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll, { passive: true });
          this.refresh();

          this.button.addEventListener('click', () => this.onClick());

          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
              if (data.sectionId !== this.sectionId) return;
              this.updatePrice(data.html);
              this.refresh();
            });
          }
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
          this.unsubscribe?.();
        }

        refresh() {
          if (!this.target?.isConnected) return;
          const isPastTarget = this.target.getBoundingClientRect().bottom < 0;
          this.hidden = !(isPastTarget && !this.target.hasAttribute('disabled'));
        }

        updatePrice(html) {
          const source = html.getElementById(`price-${this.sectionId}`);
          if (!source || !this.priceElement) return;
          const onSale = source.querySelector('.price--on-sale');
          const node = onSale
            ? source.querySelector('.price__sale .price-item--sale')
            : source.querySelector('.price__regular .price-item--regular');
          if (node) this.priceElement.textContent = node.textContent.trim();
        }

        onClick() {
          if (this.dataset.singleVariant === 'true') {
            this.target.click();
            return;
          }
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
